import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    TransformResponse
} from '../../subject/src/transform';

import {
    addAction as addPatientGlobalSearch,
    setSpin,
} from 'one-state-patient-global-search';
import {format} from 'one-util-date';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction as lookupErrorSet,
} from "one-state-subjecterror/src/action";

export const enum Types {
    SEARCH = 'one-state-patient-global-search/search',
    ADD = 'one-state-patient-global-search/add',
    PushDatatoSubject = 'one-state-subject/set',
}

const pushToSetPatientGlobalSearch = (payload: any) => addPatientGlobalSearch(payload);

/**
 * This Function fetches data from getpatientsearchglobal api
 * @param context contains settings.json etc...
 */
export const fetchPatientsGlobalSearchEpic = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server,
            log,
            settings:
            {
                epicendpoints: { patientsearch, apitoken }
            }
        } = context;
        return action$.pipe(
            ofType(Types.SEARCH),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient global search request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "patient-global-search request", dataresponse);
                const getCallerDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    const data = {
                        "Name": payload.name ? payload.name : "",
                        "DateOfBirth": payload.birthdate ? payload.birthdate : "",
                        "PhoneNumber": payload.phone ? payload.phone : ""
                    }
                    const response = server.post({
                        path: patientsearch,
                        data: data,
                        headers: headers
                    }).then((responsefound: any) => responsefound)
                        .catch((responseresult: any) => {
                            log.error("one-epic", "patient-global-search-epic Error", responseresult);
                                let pgserror: ErrorObject = {
                                    source: "Patient Global Search",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return pgserror;
                        })
                    log.debug("one-epics", "patient-global-search-epic response", response);
                    return from(response);
                }
                return getCallerDetails(dataresponse).pipe(
                    map(response => TransformResponse(response, context))
                ).pipe(
                    flatMap(response => {
                        const payloadPhone = dataresponse.phone ? dataresponse.phone.replace(/\D/g,'') : null;
                        const responseData = response.subjectdata.map((subject: any) => {
                            if (payloadPhone) {
                                subject.phoneNumbers = subject.phoneNumbers.filter((item: any) =>  item.Number.replace(/\D/g,'') === payloadPhone)
                            }
                            subject.phone = subject.phoneNumbers?.length > 0 ? subject.phoneNumbers[0] : {}
                            return subject
                        })
                        const actions: any = [
                            pushToSetPatientGlobalSearch(responseData)
                        ];
                        // check for error messages.
                        if (response.error) {
                            actions.push(addAction(response.error));
                             //To store the error object in the reducer.
                             actions.push(lookupErrorSet(response.error));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Fuction will stop spinner for 
 * patient global search epic redux action
 * @param context contains the settings,logger etc..
 */
export const resetSpinForPateintGlobalSearchEpic = (context: any) => (
    (action$: any) => {
        const { log} = context;
        log.debug(
            "ccw-gadget,patient-global-search-epic",
            "setSpin-patient-global-search-epic", {
            });
        return action$.pipe(
            ofType(Types.ADD),
            map(action => setSpin(false))
        )
    }
);
